<template>
    <v-dialog
        :value="isOpen"
        max-width="1000px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Wybierz czynność
                </h1>
            </v-card-title>

            <v-card-text>
                <v-container class="pa-0">
                    <v-row>
                        <v-col v-for="(item, index) in reportProcesses" :key="index" cols="auto">
                            <div class="my-2">
                                <v-btn
                                    color="grey"
                                    x-large
                                    dark
                                    rounded
                                    :class="{
                                        'button-size-80': item.isSelected || !item.isSelected,
                                        'success': item.isSelected,
                                    }"
                                    class="button-size-80"
                                    @click="updateProcessCode(item)"
                                >
                                    {{ item.name }}
                                </v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    :disabled="actionLoading"
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    :loading="actionLoading"
                    data-sentry-label="Rozpocznij"
                    :disabled="!processCode"
                    @click="createReport"
                >
                    Rozpocznij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'CreateShipmentProcessReportDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        reportProcessesData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            processCode: null,
            actionLoading: false,
            reportProcesses: []
        }
    },
    computed: {
        userId() {
            return this.$store.state.user.userId
        },
        sendingsSettings() {
            return this.$store.state.shipments.sendings.sendings.sendingsSettings
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.reportProcesses = JSON.parse(JSON.stringify(this.reportProcessesData))
                this.reportProcesses.map(process => process.isSelected = false)
            }
        }
    },
    methods: {
        updateProcessCode(item) {
            this.processCode = item

            this.reportProcesses.map(process => {
                if (process.id !== item.id) {
                    process.isSelected = false
                }
            })
            const index = this.reportProcesses.findIndex((process => process.id === item.id))

            this.reportProcesses.splice(index, 1, {...item, isSelected: true})
        },

        createReport() {
            this.actionLoading = true

            this.$store.dispatch('shipments/sendings/createShipmentReport', {
                reportProcessCodeId: this.processCode.id,
                productionSiteId: this.sendingsSettings.workspace.id
            })
                .then(response => {
                    this.$router.push({
                        name: 'shipmentsSendingsReport',
                        params: {
                            id: response.id,
                        }
                    })
                        .catch(error => {
                            errorHandler(error)
                        })
                })
                .catch(error => errorHandler(error))
                .finally(() => {
                    this.onClose()
                })
        },
        onClose() {
            this.actionLoading = false
            this.processCode = null
            this.$emit('on-close')
        }
    }
}
</script>